import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";

export const Root = styled(Container)(({ theme }) => ({
  marginTop: 44,
  marginBottom: 45,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 56,
    marginBottom: 67,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 98,
    marginBottom: 131,
  },
}));

export const Title = styled(Typography)({
  marginTop: 44,
  marginBottom: 35,
});

export const Subtitle = styled(Typography)(({ theme }) => ({
  marginBottom: 30,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 22,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 38,
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.large.fontSize,
  },
}));

export const Icon = styled("img")(({ theme }) => ({
  width: 116,
  marginTop: 30,
  marginBottom: 30,
  [theme.breakpoints.up("mobile")]: {
    width: 162,
    marginTop: 52,
    marginBottom: 18,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 256,
    marginTop: 100,
    marginBottom: 60,
  },
}));

export const StoresContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: 30,
  "& a:first-of-type": {
    marginRight: 20,
  },
  [theme.breakpoints.up("mobile")]: {
    marginTop: 47,
    "& a:first-of-type": {
      marginRight: 50,
    },
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 80,
    "& a:first-of-type": {
      marginRight: 85,
    },
  },
}));

export const Image = styled("img")(({ theme }) => ({
  width: 115,
  [theme.breakpoints.up("mobile")]: {
    width: 163,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 255,
  },
}));
